var BASWebServices;
(function (BASWebServices) {
    var VersionService = (function () {
        function VersionService($http, cmdiOptions) {
            this.$http = $http;
            this.cmdiOptions = cmdiOptions;
            this.versionPromises = {};
            var allServiceNames = ["services",
                "runAnnotConv",
                "runAnonymizer",
                "runAudioEnhance",
                "runASR",
                "runChannelSeparator",
                "runChunker",
                "runChunkPreparation",
                "runCOALA",
                "runEMUMagic",
                "runFormantAnalysis",
                "runG2P",
                "runMAUS",
                "runMINNI",
                "runPho2Syl",
                "runPipeline",
                "runPipelineWithASR",
                "runSpeakDiar",
                "runSubtitle",
                "runTextEnhance",
                "runVoiceActivityDetection"
            ];
            for (var currIdx in allServiceNames) {
                var currServiceName = allServiceNames[currIdx];
                this.versionPromises[currServiceName] = this.getVersionPromiseFromServer(BASWebServices.ConfigService.GET_VERSION_SERVICE_URL(), currServiceName);
            }
        }
        VersionService.Factory = function ($http, cmdiOptions) {
            return new VersionService($http, cmdiOptions);
        };
        VersionService.prototype.getVersionPromise = function (serviceName) {
            return this.versionPromises[serviceName];
        };
        VersionService.prototype.getVersionPromiseFromServer = function (pathToGetVersionService, serviceName) {
            var versionPromise = this.$http({
                method: 'GET',
                url: pathToGetVersionService + "?service=" + serviceName
            });
            return versionPromise;
        };
        return VersionService;
    }());
    BASWebServices.VersionService = VersionService;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=VersionService.js.map